import { BRAND } from "../../brand";
import { FIRMWARE_UPDATE_STEPS } from "../../constants/firmware";

export default function FirmwareProgress({ updateEntry, percent, step, onCancel }) {
  const nodeName = updateEntry?.nodeName ?? "Device";
  return (
    <div className="space-y-4">
      <section className="space-y-1 text-center">
        <p className="text-sm font-semibold text-brand-light">Updating Firmware...</p>
        <p className="text-xs text-brand-light/70">Node: {nodeName}</p>
      </section>

      <div className="flex items-center justify-center">
        <div
          className="relative h-32 w-32 rounded-full flex items-center justify-center"
          style={{
            backgroundImage: `conic-gradient(${BRAND.magenta} 0deg, ${BRAND.magenta} ${
              percent * 3.6
            }deg, #3a2570 ${percent * 3.6}deg, #3a2570 360deg)`,
          }}
        >
          <div className="absolute inset-[10px] rounded-full bg-brand-navy border border-brand-purple flex items-center justify-center">
            <span className="text-2xl font-semibold text-brand-light">{percent}%</span>
          </div>
        </div>
      </div>

      <section className="space-y-3">
        {FIRMWARE_UPDATE_STEPS.map((label, idx) => {
          const done = idx < step;
          const active = idx === step;
          return (
            <div key={label} className="flex items-center gap-3">
              <span
                className={`flex h-8 w-8 items-center justify-center rounded-full ${
                  done || active ? "bg-brand-magenta text-brand-navy" : "bg-brand-purple text-brand-light/60"
                }`}
              >
                {done ? "✔" : "●"}
              </span>
              <span
                className={`text-sm ${
                  done ? "text-brand-light" : active ? "text-brand-magenta font-semibold" : "text-brand-light/50"
                }`}
              >
                {label}
              </span>
            </div>
          );
        })}
      </section>

      <section className="rounded-2xl border border-brand-magenta/60 bg-brand-magenta text-white px-4 py-3 space-y-2 shadow-lg shadow-brand-magenta/30">
        <div className="flex items-start gap-3">
          <span className="text-xl">⏻</span>
          <div className="flex flex-col gap-1 flex-1">
            <span className="text-sm font-semibold">Important Safety Notice</span>
            <p className="text-sm text-white/90">
              Do not turn off vehicle power or disconnect from the {nodeName} during the update.
            </p>
          </div>
        </div>
      </section>

      {onCancel && (
        <button
          type="button"
          onClick={onCancel}
          className="w-full rounded-2xl bg-brand-magenta px-4 py-3 text-sm font-semibold text-white shadow hover:bg-brand-pink transition active:scale-[0.99]"
        >
          Cancel Update
        </button>
      )}
    </div>
  );
}
